import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import {
  CalculateByDays,
  CLEAR_COSTS,
  ForSubmit,
  GET,
  CREATE,
  UPDATE,
  REMOVE
} from '@hobs/constants/serviceRequests';

export function calculateByDays(body) {
  return dispatch => {
    dispatch(request());

    return fetchSecure('ServiceRequests/CalculateByDays', {
      body: body,
      method: 'POST'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CalculateByDays.REQUEST };
  }
  function success(results) {
    return { type: CalculateByDays.SUCCESS, results };
  }
  function failure(error) {
    return { type: CalculateByDays.FAILURE, error };
  }
}

export function clearCalculateByDays() {
  return dispatch => {
    dispatch({ type: CLEAR_COSTS.SUCCESS });
  };
}

export function forSubmit() {
  return dispatch => {
    dispatch(request());

    return fetchSecure('ServiceRequests/ForSubmit')
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: ForSubmit.REQUEST };
  }
  function success(results) {
    return { type: ForSubmit.SUCCESS, results };
  }
  function failure(error) {
    return { type: ForSubmit.FAILURE, error };
  }
}

export function getServiceRequest(serviceRequestsId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(`ServiceRequests/${serviceRequestsId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GET.REQUEST };
  }

  function success(item) {
    return { type: GET.SUCCESS, item };
  }
  function failure(error) {
    return { type: GET.FAILURE, error };
  }
}

export function create(data) {
  return dispatch => {
    dispatch(request());

    return fetchSecure('ServiceRequests', { body: data, method: 'POST' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CREATE.REQUEST };
  }
  function success(results) {
    return { type: CREATE.SUCCESS, results };
  }
  function failure(error) {
    return { type: CREATE.FAILURE, error };
  }
}

export function update(data) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`ServiceRequests/${data.serviceRequestId}`, {
      body: data,
      method: 'PUT'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UPDATE.REQUEST };
  }

  function success() {
    return { type: UPDATE.SUCCESS };
  }
  function failure(error) {
    return { type: UPDATE.FAILURE, error };
  }
}

export function remove(serviceRequestId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(
      `StatementOfRequirements/ServiceRequests/${serviceRequestId}`,
      { method: 'DELETE' }
    )
      .then(response => {
        if (response.status === 200) {
          dispatch(success());

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: REMOVE.REQUEST };
  }
  function success() {
    return { type: REMOVE.SUCCESS };
  }
  function failure(error) {
    return { type: REMOVE.FAILURE, error };
  }
}
